export default "__VITE_ASSET__BFOi9dVK__"